import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { UpdateChatSessionRequest } from '../../../services/chat/interfaces/IChatSessionWriteService';
import { UpdateChatSessionCommand } from '../models/UpdateChatSessionCommand';
import { Agent, NexusAgent } from '../../../domain/agents/models/Agent';
import { isNexusAgent } from '../../../features/utils/AgentUtils';

export interface MapUpdateChatSessionCommandToProviderRequestInput {
	command: UpdateChatSessionCommand;
	session: ChatSession;
	resolvedAgent?: Agent | null;
}

export const mapUpdateChatSessionCommandToProviderRequest = ({
	command,
	session,
	resolvedAgent,
}: MapUpdateChatSessionCommandToProviderRequestInput): UpdateChatSessionRequest => {
	if (session.providerType === ChatProviderType.ProGPT) {
		return {
			providerType: ChatProviderType.ProGPT,
			chatId: session.id,
			title: command.title,
			persona: command.persona,
			isTitleGenerated: command.isTitleGenerated,
		};
	}

	if (session.providerType === ChatProviderType.Nexus) {
		// TODO: once document uploads/tab are implemented this will need to be modified to pass the correct files as well
		const nexusAgent: NexusAgent | null = isNexusAgent(resolvedAgent ?? null) ? (resolvedAgent as NexusAgent) : null;
		const enableFileSearch =
			nexusAgent?.allowFileSearchAtConversationLevel === true;
		const enableCodeInterpreter =
			nexusAgent?.allowCodeInterpreterAtConversationLevel === true;

		return {
			providerType: ChatProviderType.Nexus,
			title: command.title,
			enableFileSearch,
			enableCodeInterpreter,
		};
	}

	throw new Error('Updating chat title is not supported for Assistants sessions yet.');
};

export default mapUpdateChatSessionCommandToProviderRequest;
